import React from 'react';
import TermsOfServiceContent from 'containers/TermsOfServiceContent';
import PageDialogOverlay from 'components/PageDialogOverlay';
import './TermsOfServicePage.css';

function TermsOfServicePage() {
  return (
    <PageDialogOverlay
      parentClassName="terms"
      headerTitle="Terms of Service"
      pageTitle="Terms of Service"
      backButtonText="Support"
      backLocation="/support"
      scrolling
    >
      <TermsOfServiceContent />
    </PageDialogOverlay>
  );
}

export default TermsOfServicePage;
